import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token'

export function getToken() {
    return Cookies.get(TokenKey)
  }
  
  export function setToken(token) {
    return Cookies.set(TokenKey, token)
  }
  
  export function getUpToken() {
    return Cookies.get('setUpToken')
  }
  
  export function setUpToken(token) {
    return Cookies.set('setUpToken', token)
  }
  
  export function removeToken() {
    return Cookies.remove(TokenKey)
  }
  
  export function removeUpToken() {
    return Cookies.remove(TokenKey)
  }

  export function setList(el, index, i, item){
    console.log(el[index].stock[i])
      let arr = el[index].stock[i];
      // arr[item] = arr[item];
      el[index].stock[i] = arr;
      return el[index];
  }
var OSS = require('ali-oss');

var client = new OSS({
  region: 'oss-cn-beijing',
  //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
  accessKeyId: 'LTAIOxa9mGEIkdQA',
  accessKeySecret: 'opiUbdL2wvcXOsUu1nsAfVFvGwjfGd',
  bucket: 'fanhuayiju'
});

// client.useBucket('Your bucket name');
export async function put (res) {
  try {
    let names = res.file.lastModified+res.file.name;
    let result = await client.put(names, res.file);
    return result;
   } catch (err) {
     console.log (err);
   }
}